import { Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from "@angular/common";


@Pipe({
  name: 'tsearch',
  pure: false
})
export class TsearchPipe implements PipeTransform {


  /**
* @param items object from array
* @param term term's search
*/
  transform(items: any, term: string): any {
    if (!term || !items) return items;
    return TsearchPipe.filter(items, term);
  }

  /**
   *
   * @param items List of items to filter
   * @param term  a string term to compare with every property of the list
   *
   */
  static filter(items: Array<{ [key: string]: any }>, term: string): Array<{ [key: string]: any }> {

    const toCompare = term.toLowerCase();


    function checkInside(item: any, term: string) {
      for (let property in item) {
        if (item[property] === null || item[property] == undefined) {
          continue;
        }
        if (typeof item[property] === 'object') {
          if (checkInside(item[property], term)) {
            return true;
          }
        }
        if (item[property].toString().toLowerCase().includes(toCompare)) {
          return true;
        }
      }
      return false;
    }

    return items.filter(function (item) {
      return checkInside(item, term);
    });
  }


  // transform(items: any[], value: string, label:string): any[] {
  //     if (!items) return [];
  //     if (!value) return  items;
  //     if (value == '' || value == null) return [];
  //     return items.filter(e => e[label].toLowerCase().indexOf(value) > -1 );

  //   }


  //   private searchKeyword: string = "";
  //   private Result = [];

  //   constructor() {
  //   }

  //   transform(items: any[], searchText: string): any[] {
  //       if (this.isObjNull(items)) return [-1];
  //       if (this.isObjNull(searchText)) return items;
  //       this.searchKeyword = searchText.toLowerCase();
  //       this.Result = items.filter(o => this.checkAgainstProperty(o.name));
  //       if (this.Result.length === 0) {
  //           return [-1];
  //       }
  //       return this.Result;
  //   }

  //   private checkAgainstProperty(property: any): boolean {
  //       let value: boolean = false;

  //       if (!this.isNullOrWhiteSpace(property)) {
  //           if (property.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) >= 0) {
  //               value = true;
  //           }
  //       }

  //       return value;
  //   }

  //   public isObjNull(obj: any, isNumber = false): boolean {
  //       let value: boolean = true;

  //       if (!isNumber && obj && obj != undefined && obj != null)
  //           value = false;
  //       else if (isNumber && obj != undefined && obj != null)
  //           value = false;

  //       return value;
  //   }

  //   public isNullOrWhiteSpace(obj: string): boolean {
  //       let value: boolean = true;

  //       if (!this.isObjNull(obj) && obj.trim() != "")
  //           value = false;

  //       return value;
  //   }

}
